import { Checkbox, Typography } from 'antd';
import React from 'react';
import { Controller } from 'react-hook-form';

export type CheckboxProps = {
  control: any;
  name: string;
  className?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
};

export const CoreCheckbox: React.FC<CheckboxProps> = (props) => {
  const { control, name, className, label, required, disabled, ...nativeProps } = props;

  return (
    <div className={className}>
      {label && (
        <Typography.Text className='w-full'>
          {label} {required ? '*' : ''}
        </Typography.Text>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <>
              <Checkbox onChange={onChange} checked={value} disabled={disabled} {...nativeProps}>
                {!label && name}
              </Checkbox>
              {error && <p className='italic text-[#F5222D]'>{error.message}</p>}
            </>
          );
        }}
      />
    </div>
  );
};
